<template>
    <v-menu
        :ref="content"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        v-model="menu"
    >
        <template v-slot:activator="{ on, attrs }" >
            <v-text-field v-if="!isChip"
                v-on="on"
                hint="Formato DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                color="primary"
                class="rounded-lg"
                :filled="!outlined"
                :outlined="outlined"
                :value="formatedDate"
                :label="label"
                :readonly="readonly"
                :error="isError"
                :rules="rules"
                :class="outlined ? 'app-text-field-outlined' : 'app-text-field-no-border'"
                v-on:keyup.enter="$emit('entered')"
                @input="handleInputTextField"
            ></v-text-field>
            <v-chip v-else
              v-bind="attrs" 
              v-on="on"
              closeable
              :close="isChip"
              @click:close="handleCloseMenu"
          >
            <template>
              {{label}}{{value ? ': '+formatedDate : ''}}
            </template>
          </v-chip>
        </template>
        <v-date-picker
            :disabled="readonly"
            v-model="content"
            no-title
            color="primary"
            locale="es"
            @change="handleNewDate"
        ></v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        name: "AppDatePicker",
        props:{
            value: String,
            label:String,
            readonly: {
                type: Boolean,
                required: false,
                default: false
            },
            outlined: {
                type: Boolean,
                default: false
            },
            rules: {
                type: Array,
                default: () => []
            },
            isChip: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                menu: false,
                content: this.value,
                isError: false, // error: #ff9898
            }
        },
        methods: {
            handleNewDate (e) {
                this.$emit('input', e);
                this.menu = false;
            },
            handleInputTextField(e) {
                let l = e.split('/');
                if (l.length==3 && l[2]!=='' && l[2].length==4 && l[1]!=='' && l[0]!=='') {
                    this.content = l[2]+'-'+l[1]+'-'+l[0];
                    if (Date.parse(this.content)) {
                        this.handleNewDate(this.content);
                        this.isError = false;
                    } else { 
                        this.isError = true;
                    }
                } else {
                    this.isError = true;
                }
            },
            handleCloseMenu() {
              if (this.isChip) {
                this.$emit('remove-filter');
              }
              this.menu = !this.menu
            },
        },
        computed:{
            formatedDate(){
                if (this.value && this.value !== '') {
                    this.value = this.value.split('T')[0];
                    let l = this.value.split("-");
                    return l[2]+'/'+l[1]+'/'+l[0];
                } else {
                    return "";
                }
            },
        },
        created() {
            if (this.isChip) {
                this.menu = true;
            }
        }
    }
</script>

<style>
  .app-date-picker-no-border .v-input__slot::before {
    border-style: none !important;
  }

  .app-date-picker-no-border .v-text-field__slot,
  .app-date-picker-no-border .v-input__prepend-inner,
  .app-date-picker-no-border .v-input__slot {
    background-color: #FFFFFF !important;
  }

  .app-date-picker-outlined.v-text-field--outlined:not(.error--text) fieldset {
    border-color: #66359B;
  }

  .app-date-picker-no-border  > div.v-input__control > .v-input__slot  {
        border: solid 1px !important;
        border-color: #66359B !important;
        color: transparent !important; 
        height: 60px !important;
    }

</style>
